import React from 'react';
import "./css/payment.css";

function PDFAddress({ dataTabelB }) {

  const nameCus1 = dataTabelB?.SNAM + "" + dataTabelB?.NAME1 + " " + dataTabelB?.NAME2;

  let T1, A1, J1;
  J1 = `จ. ${dataTabelB?.PROVDES}`;
  if (dataTabelB?.PROVCOD === "01") {
    T1 = `แขวง ${dataTabelB?.TUMB}`;
    A1 = `เขต ${dataTabelB?.AUMPDES}`;
  } else {
    T1 = `ต.${dataTabelB?.TUMB}`;
    A1 = `อ.${dataTabelB?.AUMPDES}`;
  }

  return (
    <div style={{ fontSize: '16px', color: '#000' }}>
      {nameCus1} (คนค้ำ{dataTabelB.GARNO}) ({dataTabelB?.CONTNO}) <br/>
      เลขที่ {dataTabelB?.ADDR1} {dataTabelB?.ADDR2} <br/>
      {T1} {A1} {J1} <br/>
      {dataTabelB?.ZIP} <br/>
      <div style={{ borderBottom: '1px solid #000', width: '100%' }}></div>
    </div>
  );
}

export default PDFAddress;